export default [
  { name: 'Hong Kong Island', code: 'HK' },
  { name: 'Kowloon', code: 'KL' },
  { name: 'New Territories', code: 'NT' }
];
